import ROUTES from '../SalesReportContainer/reportRoutes';
import { createProductServiceSalesHashLink } from '../common/createProductServiceSalesNavLink';

export default createProductServiceSalesHashLink({
  route: ROUTES.SALES_REPORT,
  includeChannel: true,
  displayName: 'SalesReportLink',
  getOnClickArgs: ({ fromDate, toDate, selectedChannel, employeeFilter }) => [
    fromDate,
    toDate,
    selectedChannel,
    employeeFilter,
  ],
});
